export default __webpack_public_path__ + "static/media/egg_icon.55928fe5.png";